import http from "../../../utils/HttpUtils";

//区域接口服务
class AreaService {
    //新建区域
    static async insert(data) {
        const apiUrl = "/base/warehouse/area/insert";
        return await http.post(apiUrl, data);
    }

    //修改区域
    static async update(data) {
        const apiUrl = "/base/warehouse/area/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询区域信息
    static async findOne(id) {
        const apiUrl = `/whArea/find/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询区域信息
    static async findPage(data) {
        const apiUrl = "/base/warehouse/area/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID删除区域信息
    static async deleteOne(id) {
        const apiUrl = `/whArea/deleteOne/${id}`;
        return await http.post(apiUrl);
    }
}

export default AreaService;
